<section class="app-settings p-4">
  <div class="setting-wrapper">
    <app-breadcrumb></app-breadcrumb>

    <div class="page-title mb-4">
      <h2>App Settings</h2>
    </div>

    <!-- Language Selection (Coming Soon) -->
    <div class="settings-card mb-4 position-relative opacity-50">
      <h3><mat-icon>language</mat-icon> Language</h3>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Select Language</mat-label>
        <mat-select disabled>
          <mat-option value="en">English</mat-option>
          <mat-option value="ta">Tamil</mat-option>
          <mat-option value="hi">Hindi</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="coming-soon-overlay">Coming Soon</div>
    </div>

   <!--  Notifications -->
<div class="settings-card mb-4">
  <h3><mat-icon>notifications</mat-icon> Notifications</h3>

  <div class="d-flex align-items-center justify-content-between">
    <span>Enable Notifications</span>
    <mat-slide-toggle
      color="primary"
      [checked]="notificationsSetting === 'Show'"
      (change)="onNotificationToggle($event)"
    >
      {{ notificationsSetting }}
    </mat-slide-toggle>
  </div>
</div>


    <!-- App Mode (Coming Soon) -->
    <div class="settings-card mb-4 position-relative opacity-50">
      <h3><mat-icon>dark_mode</mat-icon> App Mode</h3>
      <div class="d-flex align-items-center justify-content-between">
        <span>Dark Mode</span>
        <mat-slide-toggle color="primary" disabled>
          {{ darkMode }}
        </mat-slide-toggle>
      </div>
      <div class="coming-soon-overlay">Coming Soon</div>
    </div>

    <!-- Buttons -->
    <div class="mt-4 d-flex justify-content-end gap-2">
      <button mat-stroked-button color="warn" (click)="resetSettings()">
        <mat-icon>restore</mat-icon> Reset Settings
      </button>

      <button mat-raised-button color="primary" (click)="saveSettings()">
        <mat-icon>save</mat-icon> Save Settings
      </button>
    </div>
  </div>
</section>